app.wachttijden = {

    settings: {

    },

    options: {
        info: false,
        paging: false,
        searching: true,
        language: {
            zeroRecords: 'Geen gegevens gevonden'
        },
        order: [[ 3, "asc" ]]
    },

    init: function() {

        if ( $('.waiting-time--table table').length > 0 ) {

            $('.waiting-time--table table').DataTable( app.wachttijden.options );

            $('.waiting-time--filter select').on('change', function() {

                $('.waiting-time--table table').DataTable().destroy();
                $('.waiting-time--table table').DataTable( app.wachttijden.options ).draw();
            });

            app.wachttijden.initCustomFilter();
        }
    },

    initCustomFilter: function() {

        // Custom filter
        $.fn.dataTable.ext.search.push(

            function( settings, data, dataIndex ) {

                var leeftijdFilter = $('[name=leeftijd_filter]').val();
                var locatieFilter = $('[name=locatie_filter]').val();
                var behandelingFilter = $('[name=behandeling_filter]').val();

                // leeftijd filter
                if ( leeftijdFilter !== '' && locatieFilter === '' && behandelingFilter === '' ) {

                    if ( data[0] !== leeftijdFilter ) {
                        return false;
                    }
                }

                // locatie filter
                if ( leeftijdFilter === '' && locatieFilter !== '' && behandelingFilter === '' ) {

                    if ( data[1] !== locatieFilter ) {
                        return false;
                    }
                }

                // behandeling filter
                if ( leeftijdFilter === '' && locatieFilter === '' && behandelingFilter !== '' ) {

                    if ( data[3] !== behandelingFilter ) {
                        return false;
                    }
                }

                // leeftijd + locatie
                if ( leeftijdFilter !== '' && locatieFilter !== '' && behandelingFilter === '' ) {

                    if ( data[0] !== leeftijdFilter || data[1] !== locatieFilter ) {
                        return false;
                    }
                }

                // leeftijd + behandeling
                if ( leeftijdFilter !== '' && locatieFilter === '' && behandelingFilter !== '' ) {

                    if ( data[0] !== leeftijdFilter || data[3] !== behandelingFilter ) {
                        return false;
                    }
                }

                // locatie + behandeling
                if ( leeftijdFilter === '' && locatieFilter !== '' && behandelingFilter !== '' ) {

                    if ( data[1] !== locatieFilter || data[3] !== behandelingFilter ) {
                        return false;
                    }
                }

                // alles
                if ( leeftijdFilter !== '' && locatieFilter !== '' && behandelingFilter !== '' ) {

                    if ( data[0] !== leeftijdFilter || data[1] !== locatieFilter || data[3] !== behandelingFilter ) {
                        return false;
                    }
                }

                return true;
            }
        );
    }
};